import { numberMask } from './cpfMask'
import { currencyMask } from './currencyMask'
import { dateMask } from './dateMask'
import { decimalMask } from './decimalMask'
import { onlyNumbersMask } from './onlyNumbersMask'
import { percentageMask } from './percentageMask'

export type MaskType = 'currency' | 'onlyNumbers' | 'percentage' | 'number' | 'date' | 'decimal'

export interface MaskProps {
  type?: MaskType
  value: string
}

export const mask = ({ type, value }: MaskProps) => {
  if (type && type === 'currency') {
    return currencyMask(value)
  }

  if (type && type === 'decimal') {
    return decimalMask(value)
  }

  if (type && type === 'onlyNumbers') {
    return onlyNumbersMask(value)
  }

  if (type && type === 'percentage') {
    return percentageMask(value)
  }

  if (type && type === 'number') {
    return numberMask(value)
  }

  if (type && type === 'date') {
    return dateMask(value)
  }

  return value
}
